(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function scrollTabIntoView(tabsContainer, tab) {
    if (!tabsContainer || !tab) return;
    
    // Get all tabs to calculate position
    var allTabs = Array.prototype.slice.call(tabsContainer.querySelectorAll('[role="tab"]'));
    var tabIndex = allTabs.indexOf(tab);
    if (tabIndex === -1) return;
    
    // Calculate cumulative width of tabs before the target tab
    var tabOffsetLeft = 0;
    for (var i = 0; i < tabIndex; i++) {
      var prevTab = allTabs[i];
      var style = window.getComputedStyle(prevTab);
      var marginLeft = parseFloat(style.marginLeft) || 0;
      var marginRight = parseFloat(style.marginRight) || 0;
      tabOffsetLeft += prevTab.offsetWidth + marginLeft + marginRight;
    }
    
    // Get gap (if using gap property)
    var containerStyle = window.getComputedStyle(tabsContainer);
    var gap = parseFloat(containerStyle.gap) || 0;
    if (gap && tabIndex > 0) {
      tabOffsetLeft += gap * tabIndex;
    }
    
    var containerWidth = tabsContainer.clientWidth;
    var tabWidth = tab.offsetWidth;
    
    // Calculate desired scroll position to center the tab
    var targetScroll = tabOffsetLeft - (containerWidth / 2) + (tabWidth / 2);
    
    // Clamp to valid scroll range
    var maxScroll = tabsContainer.scrollWidth - containerWidth;
    targetScroll = Math.max(0, Math.min(targetScroll, maxScroll));
    
    // Smooth scroll
    tabsContainer.scrollTo({
      left: targetScroll,
      behavior: 'smooth'
    });
  }


  function activateTab(sectionEl, tabs, panels, nextIndex, tabsContainer) {
    tabs.forEach(function (tab, i) {
      var active = i === nextIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.setAttribute('tabindex', active ? '0' : '-1');
    });
    panels.forEach(function (panel, i) {
      var active = i === nextIndex;
      if (active) {
        panel.classList.add('is-active');
        // Hydrate lazily: move children out of <template> on first activation
        var tpl = panel.querySelector('template[data-theme-template]');
        if (tpl && tpl.content && !panel.__hydrated) {
          while (tpl.content.childNodes.length > 0) {
            panel.appendChild(tpl.content.childNodes[0]);
          }
          panel.__hydrated = true;
          if (tpl.parentNode) {
            tpl.parentNode.removeChild(tpl);
          }
        }
      } else {
        panel.classList.remove('is-active');
      }
    });

    // Scroll active tab into view
    if (tabsContainer && tabs[nextIndex]) {
      scrollTabIntoView(tabsContainer, tabs[nextIndex]);
    }

    // Persist selection per section
    var id = sectionEl && sectionEl.getAttribute('data-section-id');
    if (id) {
      try {
        sessionStorage.setItem('featured-themes:' + id, String(nextIndex));
      } catch (e) {}
    }
  }

  function initTabs() {
    var sections = document.querySelectorAll('.featured-collection--root');
    sections.forEach(function (root) {
      var tabsWrapper = root.querySelector('.featured-themes--tabs-wrapper');
      if (!tabsWrapper) return;
      
      var tabsContainer = root.querySelector('.featured-themes--tabs');
      if (!tabsContainer) return;

      var tabs = Array.prototype.slice.call(tabsContainer.querySelectorAll('[role="tab"]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('.featured-themes--panel'));
      if (tabs.length === 0 || panels.length === 0) return;

      // Skip if already initialized
      if (tabsContainer.dataset.initialized === 'true') return;
      tabsContainer.dataset.initialized = 'true';

      // If only one theme, hide tabs
      if (tabs.length === 1) {
        tabsWrapper.style.display = 'none';
        return;
      }


      // Restore last active from sessionStorage
      var id = root.getAttribute('data-section-id');
      var startIndex = 0;
      try {
        var saved = sessionStorage.getItem('featured-themes:' + id);
        if (saved != null) {
          var n = parseInt(saved, 10);
          if (!isNaN(n) && n >= 0 && n < tabs.length) startIndex = n;
        } else {
          // pick initial marked as is-active
          for (var i = 0; i < tabs.length; i++) {
            if (tabs[i].classList.contains('is-active')) {
              startIndex = i;
              break;
            }
          }
        }
      } catch (e) {}

      // Delay scroll into view to ensure layout is complete
      setTimeout(function () {
        activateTab(root, tabs, panels, startIndex, tabsContainer);
      }, 100);

      // Click behavior
      tabs.forEach(function (tab, idx) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          activateTab(root, tabs, panels, idx, tabsContainer);
          tab.focus({ preventScroll: true });
        });
      });

      // Keyboard navigation
      tabsContainer.addEventListener('keydown', function (e) {
        var key = e.key;
        var current = -1;
        for (var i = 0; i < tabs.length; i++) {
          if (tabs[i].classList.contains('is-active')) {
            current = i;
            break;
          }
        }
        var next = null;
        if (key === 'ArrowRight' || key === 'ArrowDown') {
          next = (current + 1) % tabs.length;
        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
          next = (current - 1 + tabs.length) % tabs.length;
        } else if (key === 'Home') {
          next = 0;
        } else if (key === 'End') {
          next = tabs.length - 1;
        } else if (key === 'Enter' || key === ' ') {
          // already handled by click when focus is on the tab
          return;
        }
        if (next != null && next !== current) {
          e.preventDefault();
          activateTab(root, tabs, panels, next, tabsContainer);
          tabs[next].focus({ preventScroll: true });
        }
      });
    });
  }

  ready(function () {
    initTabs();
  });

  // Also run after DOM mutations (for dynamic content)
  if (typeof MutationObserver !== 'undefined') {
    var initTimeout;
    var observer = new MutationObserver(function () {
      clearTimeout(initTimeout);
      initTimeout = setTimeout(function () {
        initTabs();
      }, 100);
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();